
// Improved version for web app with better fallbacks and error handling

export const initCapacitor = async () => {
  try {
    // For web, we return false for isNative but handle it gracefully
    return {
      isNative: false,
      platform: 'web'
    };
  } catch (error) {
    console.error("Error initializing Capacitor:", error);
    // Return default values even if initialization fails
    return {
      isNative: false,
      platform: 'web'
    };
  }
};

export const hideSplashScreen = async () => {
  try {
    // No-op for web
    return;
  } catch (error) {
    console.error("Error hiding splash screen:", error);
    // Silent fail for web
  }
};
